import {makeGet} from '@yandex-delivery/utils'

import type {Order as FormValues} from '../../../types'
import {DestinationPointDeliveryMethod} from '../../../types'
import {toDestinationPoints} from '../../../utils/to-destination-point'

export function withEmptyDestinationPoint(zoneName?: string) {
  const sddClaimInfo = undefined
  const isCard = true

  return function _withEmptyDestinationPoint(formValues: FormValues) {
    const sourceCity = getSourceCity(formValues)
    const destinationCity = getDestinationCity(formValues)
    const shouldEraseDestinationPoint = zoneName && (sourceCity !== destinationCity || destinationCity === '')

    if (shouldEraseDestinationPoint) {
      formValues.destinationPoints = toDestinationPoints(
        sddClaimInfo,
        isCard,
        DestinationPointDeliveryMethod.PickUpPoint,
      )
    }

    return formValues
  }
}

const valuesGet = makeGet<FormValues>()
export const getSourceCity = valuesGet('sourcePoint.address.city')
export const getDestinationCity = valuesGet('destinationPoints[0].address.city')
